export default {"src":"/_next/static/media/semi-detached-icon.b823bb73.svg","height":86,"width":124,"blurWidth":0,"blurHeight":0};